import React from 'react';
import { Helmet } from 'react-helmet';
import useBotPagesConfig from '../../hooks/useBotPagesConfig';

interface DocumentHeadProps {
    title?: string;
    description?: string;
}

const DocumentHead: React.FC<DocumentHeadProps> = ({ title, description }) => {
    const { title: configTitle, styles } = useBotPagesConfig();

    const fullTitle = title ? `${configTitle} ${title}` : configTitle;

    return (
        <Helmet>
            <title>{fullTitle}</title>
            <meta name='description' content={description} />
            <meta name='og:title' property='og:title' content={fullTitle} />
            <meta property='og:image' content={styles?.logoUrl} />
            <meta property='og:type' content='website' />
            <meta property='og:site_name' content='Help pages' />
            <meta property='og:description' content={description} />
        </Helmet>
    );
};

export default DocumentHead;
